export default __webpack_public_path__ + "static/media/HomeButtonBlack.f4fdd226.svg";